export const Rotas = {
  ROTAS: '/rotas',
  // Auth Pages
  LOGIN: '/login',
  RECUPERAR_SENHA: '/autenticacao/recuperar-senha',
  NOVA_SENHA: '/autenticacao/nova-senha',
  ERROR_NOT_FOUND: '*',
  // Menu Pages
  MENU: '/menu',
  // Simulacao Pages
  INICIO: '/simulacao/inicio',
  GRUPOS: '/simulacao/grupos',
  PRODUTOS: '/simulacao/produtos',
  DETALHE_PRODUTO: '/simulacao/detalhe-produto',
  CARRINHO: '/simulacao/carrinho',
  IDENTIFICACAO_CLIENTE: '/simulacao/cliente/identificacao',
  METODO_PAGAMENTO: '/simulacao/cliente/metodo-pagamento',
  DESCONTOS: '/simulacao/cliente/descontos',
  DOCUMENTOS: '/simulacao/cadastro/documentos',
  REGISTRO_CLIENTE: '/simulacao/cadastro/formulario',
  DEVOLUCAO: '/simulacao/pagamento/devolucao',
  SEGURO: '/simulacao/pagamento/seguro',
  RESUMO: '/simulacao/pagamento/resumo',

  CONTRATO_ENVIADO: '/simulacao/contrato-enviado',
  CONTRATO_DIGITAL: '/simulacao/contrato-digital',
  CONTRATO_MANUAL: '/simulacao/contrato-manual',
  CONTRATO_MANUAL_DOWNLOAD: '/simulacao/contrato-manual/download',

  CONTRATO_VALIDACAO_TOKEN: '/permissao-token-contrato/:codigo',
  CONTRATO_VISUALIZACAO: '/visualizacao-contrato',

  CREDITO_STATUS: '/simulacao/credito-status',
  CREDITO_STATUS_RESULT_REPROVED: '/analise/credito-reprovado',
  CREDITO_STATUS_RESULT_PENDING: '/analise/credito-pendente',
  // Management Pages
  CONTRATOS: '/gestao/contratos',
  DASHBOARD_MANAGEMENT: '/gestao/dashboard',
  PAINEL_ANALITICO_GRUPOS: '/gestao/painel-analitico-grupos',
  // Documentation Pages
  DOCUMENTACAO: '/documentacao-aprovacao',
  // Flexibilization Pages
  FLEXIBILIZACAO: '/flexibilizacao',
  // Confirmation Contemplation Pages
  CONFIRMATION_CONTEMPLATION: '/confirmacao-contemplacao',
  // Credit Letter Pages
  CREDIT_LETTER: '/emissao-carta-credito',
  // Credit Card Usage Pages
  CREDIT_CARD_USAGE: '/utilizacao',
  CREDIT_CARD_USAGE_CONSULT: '/utilizacao/consultar',
  CREDIT_CARD_USAGE_REGISTER: '/utilizacao/registro',
  CREDIT_CARD_USAGE_CONSULT_PROCESS: '/utilizacao/consultar-processo',
  CREDIT_CARD_USAGE_EMITIR_INSTRUMENTO: '/utilizacao/emitir-instrumento-alienacao',
  // Publicidade Pages
  PUBLICIDADE: '/publicidade',
  // Usuários Pages
  USUARIOS: '/usuarios'
}
